export default __webpack_public_path__ + "static/media/ynscreen.a4bd1991.png";